import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!

  return (_openBlock(), _createBlock(_component_ag_grid_vue, {
    class: "ag-theme-alpine landscape-details-grid",
    "row-class": "landscape-details-grid-row",
    columnDefs: $data.columnDefs,
    rowData: $props.params?.data?.detail,
    "row-selection": $props.params?.masterSelected ? 'single' : undefined,
    onRowSelected: $options.onRowSelected,
    "suppress-context-menu": true,
    "suppress-cell-focus": "true",
    "dom-layout": "autoHeight"
  }, null, 8, ["columnDefs", "rowData", "row-selection", "onRowSelected"]))
}